// extracted by mini-css-extract-plugin
export default {"gif":"k_bf","gif--wrapped":"k_bg"};